import connect from './connect'
import OrderSearch from './OrderSearch'

export default connect(OrderSearch)
